import React from 'react';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import Header from '../Components/Header';
import kundliImage from "../Assets/Images/section2-1.png";
import vastuImage from "../Assets/Images/section2-2.png";
import yagyaImage from "../Assets/Images/section2-3.png";
import aboutUs4 from '../Assets/Gallery/4.jpg';
import aboutus3 from '../Assets/Gallery/3.jpg';
import ptKamleshSharmaImage from '../Assets/Images/aboutusimage.jpg';
import Footer from "../Components/Footer";

const AboutUs = () => {
  return (
    <div>
      <Header />
      <div className="bg-black text-white py-12 px-6 md:px-16">
        <div className="container mx-auto">
          
          {/* Section 1: Introduction */}
          <motion.section
            className="md:flex md:items-center mb-12"
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <div className="md:w-1/2">
              <img src={ptKamleshSharmaImage} alt="Pt. Kamlesh Sharma" className="w-full rounded-lg shadow-lg" />
            </div>
            <div className="md:w-1/2 md:pl-8">
              <h3 className="text-3xl font-semibold mb-4">Pt. Kamlesh Sharma – Renowned Vedic Astrologer & Spiritual Guide</h3>
              <p className="text-gray-400 text-lg mb-4">
                Welcome to the world of divine wisdom and astrological guidance with Pt. Kamlesh Sharma. A highly experienced Vedic astrologer, he has helped countless individuals find clarity, peace, and success through the power of astrology.
              </p>
              <p className="text-gray-400 text-lg mb-4">
                Located in Sitabuldi, Nagpur, Pt. Kamlesh Sharma provides expert astrology consultations at the Shri Radha Krishna Mandir, where he also performs sacred rituals and spiritual services. The temple houses the Sri Satyanarayan Yagya Shala, a dedicated space for Mahamrityunjay Yagya, Havan, and other Vedic pujas to bring positive energy and divine blessings.
              </p>
              <p className="text-gray-400 text-lg mb-6">
                With expertise in Kundli analysis, birth chart readings, horoscope predictions, love compatibility, career astrology, and spiritual remedies, Pt. Kamlesh Sharma has been a guiding light for those seeking solutions to life’s challenges. His deep knowledge of ancient scriptures and astrological sciences has earned him a reputation for providing accurate predictions and effective remedies.
              </p>
              <Link to="/contact" className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full">
                Contact Now
              </Link>
            </div>
          </motion.section>

          {/* Section 2: Services Offered */}
          <motion.section
            className="mb-12"
            whileInView={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.2 }}
          >
            <h3 className="text-3xl font-semibold mb-4 text-center">Our Services</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <motion.div
                className="bg-[#0A2239] p-6 rounded-lg shadow-lg text-center border border-gray-700"
                whileInView={{ opacity: 1, scale: 1 }}
                initial={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <img src={kundliImage} alt="Kundli Analysis" className="w-20 h-20 mx-auto mb-4 object-cover" />
                <h4 className="text-2xl font-semibold mb-2">Kundli Analysis</h4>
                <p className="text-gray-400">Gain deep insights into your life's journey with our expert Kundli and Birth Chart Analysis.</p>
              </motion.div>

              <motion.div
                className="bg-[#0A2239] p-6 rounded-lg shadow-lg text-center border border-gray-700"
                whileInView={{ opacity: 1, scale: 1 }}
                initial={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <img src={vastuImage} alt="Vastu Consultation" className="w-20 h-20 mx-auto mb-4 object-cover" />
                <h4 className="text-2xl font-semibold mb-2">Vastu Consultation</h4>
                <p className="text-gray-400">Create harmonious living and working spaces with our expert Vastu guidance.</p>
              </motion.div>

              <motion.div
                className="bg-[#0A2239] p-6 rounded-lg shadow-lg text-center border border-gray-700"
                whileInView={{ opacity: 1, scale: 1 }}
                initial={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <img src={yagyaImage} alt="Mahamrityunjay Yagya" className="w-20 h-20 mx-auto mb-4 object-cover" />
                <h4 className="text-2xl font-semibold mb-2">Mahamrityunjay Yagya</h4>
                <p className="text-gray-400">Invoke divine blessings and overcome obstacles with this powerful Vedic ritual.</p>
              </motion.div>
            </div>
          </motion.section>

          {/* Section 3: Visit Us */}
          <motion.section
            className="text-center"
            whileInView={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.2 }}
          >
            <img src={aboutUs4} alt="Temple View" className="w-full rounded-lg shadow-lg mb-8 h-[300px] object-cover" />
            <p className="text-lg text-gray-400 mb-4">📍 Visit Us at: Shri Radha Krishna Mandir, Sitabuldi, Nagpur</p>
            <p className="text-lg text-gray-400">📞 Contact Us: 8087577777</p>
          </motion.section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
